import React from "react";
import { Link } from "react-router-dom";
import PageShell from "../components/PageShell";
import { hristinaImage } from "../mock";
import { ArrowRight, Heart, Sparkles } from "lucide-react";

export default function About() {
  return (
    <PageShell kicker="Our Story" title="Life is full of stories, Jesus is designing yours" subtitle="Every mug, shirt and gift box we send out was designed with prayer.">
      <section className="max-w-6xl mx-auto px-5 lg:px-8 py-16 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div className="rounded-2xl overflow-hidden shadow-[0_20px_60px_-20px_rgba(20,36,61,0.35)]">
          <img src={hristinaImage} alt="Hristina, founder" className="w-full h-[560px] object-cover" />
        </div>
        <div>
          <h2 className="font-serif text-3xl md:text-4xl text-[color:var(--dms-navy)] leading-tight">A brand born from broken seasons</h2>
          <div className="w-14 h-[2px] bg-[color:var(--dms-peach)] mt-4" />
          <p className="mt-6 text-[color:var(--dms-navy)]/75 leading-relaxed">I started Design My Story after walking through seasons of brokenness where only God’s grace carried me. This brand exists to remind every person that no matter what their past holds, Jesus is still writing their story – with purpose, beauty and love.</p>
          <p className="mt-4 text-[color:var(--dms-navy)]/75 leading-relaxed">Every design starts with prayer. Every proof is reviewed by human eyes. And every order is packed with the reminder that someone, somewhere, is walking their story with you.</p>
          <blockquote className="mt-6 border-l-4 border-[color:var(--dms-peach)] pl-5 italic text-[color:var(--dms-navy)]/80 font-serif text-lg">
            “For I know the plans I have for you,” declares the Lord, “plans to prosper you and not to harm you, plans to give you hope and a future.”
            <footer className="not-italic text-sm font-sans mt-2 text-[color:var(--dms-peach)] font-semibold tracking-wider">JEREMIAH 29:11</footer>
          </blockquote>
          <p className="mt-6 font-serif italic text-[color:var(--dms-navy)]">— Hristina, founder</p>
        </div>
      </section>

      <section className="bg-[color:var(--dms-cream-2)] py-16">
        <div className="max-w-4xl mx-auto px-5 grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
          {[{ icon: Heart, title: "Designed with prayer", desc: "Every design starts on paper with a verse in mind." }, { icon: Sparkles, title: "Human review, always", desc: "We send you a proof before we print a single shirt." }, { icon: ArrowRight, title: "Same-day replies", desc: "Every message answered within one business day." }].map((c, i) => (
            <div key={i} className="bg-white rounded-2xl p-6 border border-[color:var(--dms-navy)]/10">
              <div className="w-12 h-12 rounded-full bg-[color:var(--dms-peach)] mx-auto flex items-center justify-center"><c.icon className="w-5 h-5 text-[color:var(--dms-navy)]" /></div>
              <p className="font-serif text-xl text-[color:var(--dms-navy)] mt-4">{c.title}</p>
              <p className="text-sm text-[color:var(--dms-navy)]/65 mt-2">{c.desc}</p>
            </div>
          ))}
        </div>
        <div className="text-center mt-10">
          <Link to="/t-shirts" className="btn-peach">Shop the collection <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </section>
    </PageShell>
  );
}
